export default __webpack_public_path__ + "static/media/teledoctor-logo.493304ef.png";